import { render, staticRenderFns } from "./proformalar.vue?vue&type=template&id=1c1acdb6&scoped=true&"
import script from "./proformalar.vue?vue&type=script&lang=js&"
export * from "./proformalar.vue?vue&type=script&lang=js&"
import style0 from "./proformalar.vue?vue&type=style&index=0&id=1c1acdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1acdb6",
  null
  
)

export default component.exports